import React from 'react';

import BusinessIcon from '@material-ui/icons/Business';
import { Loading, ShowProps, useShowController } from 'react-admin';

import { EmployerShowForm } from '../EmployerShowForm';

export const icon = BusinessIcon;

export const EmployersShow: React.FC<ShowProps> = props => {
  const { record } = useShowController(props);

  if (!record) {
    return <Loading />;
  }

  return <EmployerShowForm {...props} />;
};
